import {
    Field,
    FormikProps
} from 'formik';
import {
    FormikRadioCardGroup,
    FormikTextInput,
    PlatformFieldset
} from "@flexinet/ui-components";
import {Alert} from '@mantine/core';
import {UserEmailsAutocomplete} from "../../users/inputs/UserEmailsAutocomplete.tsx";
import {AccountFormType} from "../types.ts";


export const FormComponent = (props: FormikProps<AccountFormType>) => {

    const editing = typeof props.values.id !== 'undefined';

    return (
        <>
            <PlatformFieldset legend={'Account Details'}>

                {editing ? (
                    <Field
                        name='email'
                        label='Root User Email'
                        description='Root user email (read-only)'
                        component={FormikTextInput}
                        readOnly
                        my={'xl'}
                    />
                ) : (
                    <Field
                        name='email'
                        label='Root User Email'
                        description='Please select user email'
                        component={UserEmailsAutocomplete}
                        withAsterisk
                        my={'xl'}
                    />
                )}

            </PlatformFieldset>

            {editing ? <PlatformFieldset legend={'Customer'}>

                {props.values.customerId ? (
                    <Field
                        name='customerId'
                        label='CustomerID'
                        description='Linked billing customer (read-only)'
                        component={FormikTextInput}
                        readOnly
                        my={'xl'}
                    />
                ) : (
                    <Alert color='yellow' variant='light' my={'xl'} title='No customer linked'>
                        This account is not linked to a billing customer yet.
                    </Alert>
                )}

            </PlatformFieldset> : null}

            <PlatformFieldset legend={'Account Type'}>

                <Field
                    name='accountType'
                    data={[{
                        label: 'STANDALONE',
                        description: 'This account is a standalone account and does not have any organization',
                        value: 'STANDALONE'
                    }, {
                        label: 'ROOT',
                        description: 'This account is a root account and is used by an organization as org admin account',
                        value: 'ROOT'
                    }, {
                        label: 'MANAGED',
                        description: 'This account is a managed account and has an organization',
                        value: 'MANAGED'
                    }]}
                    component={FormikRadioCardGroup}
                    withAsterisk
                    my={'xl'}
                />


            </PlatformFieldset>

            <PlatformFieldset legend={'Status'}>

                <Field
                    name='accountStatus'
                    data={[{
                        label: 'ACTIVE',
                        value: 'ACTIVE'
                    }, {
                        label: 'SUSPENDED',
                        value: 'SUSPENDED'
                    }]}
                    component={FormikRadioCardGroup}
                    withAsterisk
                    my={'xl'}
                />

            </PlatformFieldset>
        </>
    );
};
